import { render, staticRenderFns } from "./CustomerAccountLimitRequest.vue?vue&type=template&id=49854f20&scoped=true&"
import script from "./CustomerAccountLimitRequest.vue?vue&type=script&lang=js&"
export * from "./CustomerAccountLimitRequest.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAccountLimitRequest.vue?vue&type=style&index=0&id=49854f20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49854f20",
  null
  
)

export default component.exports